import { forwardRef } from 'react'
import { AghanimIcon } from '@dashboard/ui'

export const NoPayment: AghanimIcon = forwardRef(function ({ ...rest }, ref) {
  return (
    <svg
      width="35"
      height="26"
      viewBox="0 0 35 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...rest}
      className="relative -left-0.5 top-0.5"
    >
      <g filter="url(#filter0_d_4651_577)">
        <path
          d="M2 7C2 3.68629 4.68629 1 8 1H27C30.3137 1 33 3.68629 33 7V17C33 20.3137 30.3137 23 27 23H8C4.68629 23 2 20.3137 2 17V7Z"
          fill="white"
        />
        <path
          d="M8 1.5H27C30.0376 1.5 32.5 3.96243 32.5 7V17C32.5 20.0376 30.0376 22.5 27 22.5H8C4.96243 22.5 2.5 20.0376 2.5 17V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
          stroke="#E2E8F0"
        />
        <path
          d="M23.0223 7.25706C23.0223 7.68748 22.6734 8.03641 22.2429 8.03641C21.8125 8.03641 21.4636 7.68748 21.4636 7.25706C21.4636 6.82664 21.8125 6.47771 22.2429 6.47771C22.6734 6.47771 23.0223 6.82664 23.0223 7.25706Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9489 4.4348C17.3874 3.99633 17.9821 3.75 18.6022 3.75H23.412C24.7032 3.75 25.75 4.79678 25.75 6.08804V10.8978C25.75 11.5179 25.5037 12.1126 25.0652 12.5511L18.0511 19.5652C17.138 20.4783 15.6577 20.4783 14.7446 19.5652L9.9348 14.7554C9.02173 13.8423 9.02174 12.362 9.9348 11.4489L16.9489 4.4348ZM18.6022 5.30869C18.3955 5.30869 18.1972 5.3908 18.0511 5.53696L11.037 12.5511C10.7326 12.8554 10.7326 13.3489 11.037 13.6532L15.8468 18.463C16.1511 18.7674 16.6446 18.7674 16.9489 18.463L23.963 11.4489C24.1092 11.3028 24.1913 11.1045 24.1913 10.8978V6.08804C24.1913 5.65762 23.8424 5.30869 23.412 5.30869H18.6022Z"
          fill="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4651_577"
          x="0"
          y="0"
          width="35"
          height="26"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4651_577" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4651_577" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
